// Copyright ©️ 2026 eVolve MEP, LLC

import type { ItemData } from '@aps_sdk/data-management';

export const itemCanBeRendered = (item: ItemData) => item.attributes.extension.type.toLowerCase().includes('autodesk');
